import React, { useState } from 'react';

export default function EmbedPage() {
  const params = new URLSearchParams(window.location.search);
  const studioURL = decodeURIComponent(params.get('studioURL') ?? '');
  const videoURL = decodeURIComponent(params.get('videoURL') ?? '');
  const thumbnailURL = videoURL.replace('.mp4', '.png');
  const title = 'View full motion';

  const [videoErrorCount, setVideoErrorCount] = useState(0);
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-gray-100">
      <div className="relative h-full w-full">
        {/* Video Title Overlay */}
        <div className="absolute left-0 top-0 z-10 rounded-2xl p-4">
          <a
            href={studioURL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-lg font-bold text-white hover:underline"
          >
            {title}
          </a>
        </div>

        <div className="h-full w-full">
          {videoErrorCount < 2 ? (
            <video
              src={videoURL}
              poster={thumbnailURL}
              controls
              className="h-full w-full object-cover"
              playsInline
              onError={(e) => setVideoErrorCount((n) => n + 1)}
            >
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="flex h-full w-full items-center justify-center bg-black text-white">
              <p>Error loading video.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
